module.exports = __webpack_public_path__ + "static/media/phoneIcon.865dc30b.svg";